import * as angular from "angular";
import {IController} from "angular";
import {Addition} from "../../../price-plan/models/addition.model";
import * as _ from "lodash";
import {ServiceType} from "../../../deliveries/types/service.type";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {PreferencesDialogService} from "../../services/preferences-dialogs-service.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {PricePlanAlertsService} from "../../../price-plan/services/price-plan-alerts.service";
import {PricePlanBundleRequestsService} from "../../../price-plan/services/price-plan-bundle-requests.service";
import {PricePlanDialogService} from "../../../price-plan/services/price-plan-dialog-service.service";
import {PricePlanBundleService} from "../../../price-plan/services/price-plan-bundle.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class programsPreferencesTabCtrl implements IController {
  preferences: any;
  programs: any;
  servicesProgramTypesMap: any;
  lineSplitConfiguration: any;

  private selectedTab: any;
  public serviceTypes: ServiceType[];
  private additions: Addition[];
  public programNames: string[];
  public programsTypeMap: any;

  /* @ngInject */
  constructor(private preferencesDialogService: PreferencesDialogService, private pricePlanBundleRequestsService: PricePlanBundleRequestsService, private pricePlanDialogService: PricePlanDialogService,
              private $log, private commonsAlertsService: CommonsAlertsService, private bringozLoaderService: BringozLoaderService, private pricePlanAlertsService: PricePlanAlertsService,
              private PricePlanService, private confirmDialogService: ConfirmDialogService, private deliveriesConstants, private pricePlanBundleService: PricePlanBundleService, private splitService: SplitService) {
  }

  $onInit() {
    this.programsTypeMap = this.splitService.getSiteProgramTypesMap();
    this.programNames = this.programs.map(p => p.name);
    this.selectedTab = 0; // 0 = General, 1 = Additions
    this.serviceTypes = this.deliveriesConstants.serviceTypes;
  }

  // ******************************
  //        Public Methods
  // ******************************

  onTabSelect(selectedTab) {
    this.selectedTab = selectedTab;

    if (selectedTab === 1) {
      this._getAdditions();
    }
  }

  // Pop-up sent to element-pop-up directive, once returned updating $preferences in server.
  onEdit(event, property, index) {
    this.preferencesDialogService.editPreferencesProperty(event, property, this.programs)
      .then((updated) => {
        const updatedValue = updated[0];
        const group = _.camelCase(updatedValue.group);

        this.preferences[group].list[index] = updatedValue;
        this.commonsAlertsService.preferencesByNameSuccess('preferences.' + property.key + '.name');
      })
      .catch((error) => {
        if (error) {
          this.commonsAlertsService.preferencesError();
        }
      })
  }

  onCreateProgram(event) {
    this.pricePlanDialogService.createProgramType(event)
      .then((payload) => {
        this._createProgramType(payload.program, payload.enabled);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onEditProgram(program, event) {
    this.pricePlanDialogService.editProgramType(event, program)
    .then((payload) => {
      this._updateProgramType(payload.program.id, payload.program);
    })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onChangeServiceDefaultProgramType(serviceTypeKey, programTypeKey) {
    this.PricePlanService.setSiteServiceProgramType(serviceTypeKey, programTypeKey)
      .then((res) => {
      })
  }

  onCreateAddition($event) {
    this.pricePlanDialogService.createAddition($event)
      .then((createdAddition) => {
        this._createAddition(createdAddition);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onEditAddition(addition, $event) {
    this.pricePlanDialogService.createAddition($event, addition)
      .then((editedAddition) => {
        this._updateAddition(editedAddition);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onDeleteAddition(addition, $event) {
    if (!addition) {
      return;
    }

    this.confirmDialogService.confirm('Delete Addition', 'Are you sure you want to delete this addition?', $event)
      .then(() => {
        this._deleteAddition(addition.id);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onChangeSplitConfigurationLineType(value) {
    if (this.lineSplitConfiguration.fulfillmentLineType === value) {
      return;
    }
    const lineSplitConfigurationCopy = angular.copy(this.lineSplitConfiguration);
    lineSplitConfigurationCopy.fulfillmentLineType = value;
    this.pricePlanBundleService.updateLineSplitConfiguration([lineSplitConfigurationCopy])
      .then((lineSplitConfiguration) => {
        this.lineSplitConfiguration = lineSplitConfiguration[0];
      });
  }

  onChangeSplitConfigurationProgramType(value, field) {
    if (this.lineSplitConfiguration[field] === value) {
      return;
    }
    const lineSplitConfigurationCopy = angular.copy(this.lineSplitConfiguration);
    if (value) {
      lineSplitConfigurationCopy[field] = this.programs.find(p => p.name === value).id;
    } else {
      lineSplitConfigurationCopy[field] = undefined;
    }
    this.pricePlanBundleService.updateLineSplitConfiguration([lineSplitConfigurationCopy])
      .then((lineSplitConfiguration) => {
        this.lineSplitConfiguration = lineSplitConfiguration[0];
      });
  }

  // ******************************
  //        Private Methods
  // ******************************

  _createProgramType(program, enabled) {
    this.bringozLoaderService.on();
    this.pricePlanBundleRequestsService.createProgram(program, enabled)
      .then((createdProgram) => {
        this.programs.push(createdProgram);
        this.pricePlanAlertsService.addProgramTypeSuccess();
      })
      .catch((error) => {
        this.$log.error(error);
        this.pricePlanAlertsService.addProgramTypeError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  _updateProgramType(programId, program) {
    this.bringozLoaderService.on();
    this.pricePlanBundleRequestsService.updateProgram(programId, program)
      .then((updatedProgram) => {

        const programIndex = _.findIndex(this.programs, (p: any) => {
          return p.id === updatedProgram.id;
        })
        if (programIndex > -1) {
          this.programs.splice(programIndex, 1, updatedProgram);
        }

        this.pricePlanAlertsService.updateProgramTypeSuccess();
      })
      .catch((error) => {
        this.$log.error(error);
        this.pricePlanAlertsService.updateProgramTypeError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  _getAdditions() {
    this.additions = [];
    this.PricePlanService.getSiteAdditions()
      .then((additions: Addition[]) => {
        this.additions = additions;
      })
  }

  _createAddition(addition: Addition) {
    this.pricePlanBundleRequestsService.createSiteAddition(addition)
      .then((createdAddition: Addition) => {
        this.additions.push(createdAddition);
        this.pricePlanAlertsService.createAdditionSuccess();
      })
      .catch((error) => {
        this.$log.error(error);
        this.pricePlanAlertsService.createAdditionError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  _updateAddition(addition: Addition) {
    this.pricePlanBundleRequestsService.updateSiteAddition(addition.id, addition)
      .then((updatedAddition: Addition) => {
        const additionIndex = _.findIndex(this.additions, (a: any) => {
          return a.id === addition.id;
        })
        if (additionIndex > -1) {
          this.additions.splice(additionIndex, 1, updatedAddition);
        }
        this.pricePlanAlertsService.updateAdditionSuccess();
      })
      .catch((error) => {
        this.$log.error(error);
        this.pricePlanAlertsService.updateAdditionError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  _deleteAddition(id) {
    this.pricePlanBundleRequestsService.deleteSiteAddition(id)
      .then(() => {
        this.additions = _.filter(this.additions, (a: Addition) => {
          return a.id !== id;
        })
        this.pricePlanAlertsService.deleteAdditionSuccess();
      })
      .catch((error) => {
        this.$log.error(error);
        this.pricePlanAlertsService.deleteAdditionError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .component('programsPreferencesTab', {
    bindings: {
      preferences: '<',
      programs: '<',
      servicesProgramTypesMap: '<',
      lineSplitConfiguration: '<'
    },
    template: require('./programs-preferences-tab.html').default,
    controller: programsPreferencesTabCtrl
  });
